import { useEffect } from 'react';
import { getBrandCar, getVehicles } from '@/selectors';
import * as connect from '@lib/azgaz-ui/connect';
import { useStore, useDispatch, useSelector } from 'react-redux';
import { State } from '@/apps/appCreator/store';
import { actions } from '../apps/appCreator/store/vehicles';

/**
 * Возвращает автомобили со специфичными для бренда данными
 */
export default function useBrandCar() {
  const dispatch = useDispatch();
  const { vehicles, loading } = useSelector(getVehicles);

  /* Получение каталога */
  useEffect(() => {
    if (!vehicles && !loading) {
      dispatch(actions.getVehicles());
    }
  }, []);

  const cars = connect.useSelector(connect.selectors.getCars);
  const state = useStore().getState() as State;
  const brandCars = vehicles && cars?.map(car => getBrandCar(state, car));

  return { brandCars, vehiclesLoading: loading };
}
